'use strict';

angular.module('atex.dam').factory('DamFieldMappingService', ['$http', '$location',
function($http, $location) {
  
  var fieldMapping;
  
  return {
    loadMapping: function() {
      fieldMapping = undefined;
      return $http.get($location.protocol()+'://'+$location.host()+':'+$location.port()+'/onecms/dam/content/configuration/fields').then(function(res) {
        fieldMapping = res.data;
      });
    },
    getMapping: function(searchTerm) {
      return fieldMapping[searchTerm];   
    }
  };
    
}]);
